var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slow-to-anger"}},[_c('div',{staticClass:"alert alert-danger",staticStyle:{"overflow":"hidden","margin":"0.5em"}},[_c('h3',[_vm._v("Internet connection?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Currently cannot reach the internet.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f8e2cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppOfflineWarning.vue
// module id = 425
// module chunks = 1